import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import {useLang} from '../../context/LanguageContext';
import {useAuth} from "../../context/AuthContext";
import DateUtils from "../../utils/dateUtils";
import Footer from "../../components/Footer";

const GeneratedHighOddsTicket = () => {
  const navigate = useNavigate();
  const { t, getBetTranslation } = useLang()
  const { hasPaid } = useAuth();
  const [games, setGames] = useState([]);
  const [totalOdd, setTotalOdd] = useState(1);


  useEffect(() => {
    const stored = localStorage.getItem('generatedHighOdds');
    if (stored) {
      const parsed = JSON.parse(stored);
      setGames(parsed);
    } else {
      navigate(-1);
    }
  }, [navigate]);

  useEffect(() => {
    if (games.length > 0) {
      let product = 1;
      games.forEach((g) => {
        const val = parseFloat(g.odd);
        if (!isNaN(val)) {
          product *= val;
        }
      });
      setTotalOdd(product);
    }
  }, [games]);

  return (
    <div className="relative min-h-screen bg-[#34495e] p-5">
      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
      >
        <FaArrowLeft />
        <span className="text-white">{t('btn.back')}</span>
      </button>

      <h1 className="text-white text-xl font-bold text-center mt-16 mb-4">
        Generated High Odds Ticket
      </h1>
      <div className="text-center mb-6">
        <p className="text-white text-lg font-semibold">
          Total Odd: {totalOdd.toFixed(2)}
        </p>
      </div>

      {games.length === 0 ? (
        <p>No games found.</p>
      ) : (
        <div className="space-y-3">
          {games.map((g) => {
            const translatedDay = DateUtils.formatDayOnly(g.day, t);

            const translatedMarketName = getBetTranslation(g.marketName);
            const translatedMarket = getBetTranslation(g.market);

            return (
              <div key={g.id} className="bg-white p-3 rounded shadow">
                {hasPaid ? (
                  <div>
                    <p className="font-bold text-sm">
                      {g.team1} vs {g.team2}
                    </p>
                    <p className="text-xs text-gray-500">
                      {translatedDay} {g.hour}
                    </p>
                    <p className="text-sm mt-1">
                      {translatedMarketName} ({translatedMarket}) -{' '}
                      <span className="font-semibold text-green-600">
                        {g.odd}
                      </span>
                    </p>
                  </div>
                ) : (
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-bold text-sm">
                        {g.team1} vs {g.team2}
                      </p>
                      <p className="text-xs text-gray-500">
                        {translatedDay} {g.hour}
                      </p>
                    </div>
                    <button
                      onClick={() => navigate('/account')}
                      className="bg-orange-500 text-white px-3 py-1 rounded text-sm"
                    >
                      Unlock
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default GeneratedHighOddsTicket;
